import { NFT as ThirdWebNFT } from "thirdweb";
import { NFT } from "./NFT";

export class NFTBuilding extends NFT {
    public readonly address: string;
    public readonly area: string;
    public readonly buildingId: string;
    public readonly floors: string;
    public readonly zipCode: string;
    public readonly smallImageUrl: string;
    public readonly imageURL: string;

    public constructor(nft: ThirdWebNFT, address: string, addressReplacedValue: string) {
        super(nft);
        const attributes = <Array<any>>(nft.metadata.attributes as any);
        for (const attribute of attributes) {
            const type = this.convertAttributeType(attribute.trait_type);
            switch (type) {
                case BuildingTraitType.ADDRESS: {
                    this.address = attribute.value;
                }
                case BuildingTraitType.AREA: {
                    this.area = attribute.value;
                }
                case BuildingTraitType.BUILDING_ID: {
                    this.buildingId = attribute.value;
                }
                case BuildingTraitType.FLOORS: {
                    this.floors = attribute.value;
                }
                case BuildingTraitType.ZIP_CODE: {
                    this.zipCode = attribute.value;
                }
                case BuildingTraitType.SMALL_IMAGE_URL: {
                    this.smallImageUrl = attribute.value;
                }
            }
        }
        this.smallImageUrl = attributes.find((attribute) => {
            return attribute.trait_type === "myWalletImageUrl";
        })?.value ?? this.imageURL;
        const id = this.buildingId.toString();
        this.imageURL = address.replace(addressReplacedValue, id);
    }

    private convertAttributeType(traitType: string): BuildingTraitType {
        if (Object.values(BuildingTraitType).includes(traitType as BuildingTraitType)) {
            return traitType as BuildingTraitType;
        }
        return null;
    }
}

enum BuildingTraitType {
    ADDRESS = "address",
    AREA = "area",
    BUILDING_ID = "buildingId",
    FLOORS = "floors",
    ZIP_CODE = "zipCode",
    SMALL_IMAGE_URL = "myWalletImageUrl"
}